import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setCheckoutBegins } from 'store/actions';
import {
	analyticsAffiliationSelector,
	analyticsCarIdSelector,
	basePriceSelector,
	isFlexSelector,
	isOccasionSelector,
	stateSelector,
	totalPricePerMonthSelector,
} from 'store/selectors';
import { getCurrentStepNumber } from 'utils/navigation';
import { trackEvent } from 'utils/trackEvent';

import { getCarIdFromUrl } from '../../../utils';

import { useHealthStatus } from './useHealthStatus';

export const useCheckoutBeginsEvent = () => {
	const store = useSelector(stateSelector);
	const totalPrice = useSelector(totalPricePerMonthSelector);
	const basePrice = useSelector(basePriceSelector);
	const affiliation = useSelector(analyticsAffiliationSelector);
	const analyticsCarId = useSelector(analyticsCarIdSelector);
	const isOccasion = useSelector(isOccasionSelector);
	const isFlex = useSelector(isFlexSelector);

	const carIdFromUrl = getCarIdFromUrl();

	const currentStepNumber = getCurrentStepNumber();
	const isAtThankYouStep = currentStepNumber === 4;
	const dispatch = useDispatch();

	const { isAppHealthy, hasAppHealthBeenChecked } = useHealthStatus({
		isOccasion,
		isFlex,
		currentStepNumber,
	});

	const eventNameForStep: { [key: number]: string } = {
		1: 'begin_checkout',
		2: 'add_shipping_info',
		3: 'add_payment_info',
	};

	useEffect(() => {
		const { leaseCarData } = store;
		if (hasAppHealthBeenChecked && isAppHealthy && !isAtThankYouStep && affiliation) {
			if (carIdFromUrl !== store.leaseCarData?.id) {
				return;
			}

			// @ts-ignore: An empty GA event is fired to clear the previous ecommerce object.
			trackEvent({
				ecommerce: null,
			});

			trackEvent({
				event: eventNameForStep[currentStepNumber],
				ecommerce: {
					items: [
						{
							currency: 'EUR',
							affiliation,
							item_id: analyticsCarId,
							item_name: leaseCarData?.vehicleData.model,
							item_brand: leaseCarData?.vehicleData.make,
							item_category: 'Auto',
							item_category2: affiliation,
							quantity: 1,
							price: totalPrice ? totalPrice : basePrice,
						},
					],
				},
			});
			dispatch(setCheckoutBegins(true));
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		isAppHealthy,
		isAtThankYouStep,
		hasAppHealthBeenChecked,
		affiliation,
		analyticsCarId,
		carIdFromUrl,
		currentStepNumber,
	]);
};
